import React from "react";
import InvoiceSimplifiedDTO from "../dtos/InvoiceSimplifiedDTO";
import DateFormatter from "features/shared/components/formatters/DateFormatter";
import RoundButton from "features/shared/components/buttons/RoundButton";
import InvoiceInfo from "./InvoiceInfo";
import InvoiceSimplifedPrices from "./InvoiceSimplifedPrices";
import { getInvoiceDetailRoute } from "features/shared/helpers/routeHelper";

interface IProps {
  invoice: InvoiceSimplifiedDTO;
}

const InvoiceDashboardRow: React.FC<IProps> = (props) => {
  // props
  const { invoice } = props;  

  // render
  return (
    <div className="row align-items-center no-gutters">
      <div className="col-6">
        <InvoiceInfo
          invoiceType={invoice.invoiceType!}
          invoiceSubType={invoice.invoiceSubType!}
          commodityDetails={invoice.commodityDetail!}
          entityLinks={invoice.entityLinks!}
        />
      </div>
      <div className="col-4 text-right">
        <div className="d-flex flex-column">
          <div>
            <InvoiceSimplifedPrices 
              totalAmount={invoice.totalAmount!}
              unpaidAmount={invoice.unpaidAmount!}
              currency={invoice.currency!}
              dueDate={invoice.dueDate!}
              showSubInfo={false}
            />
          </div>
          <small className="text-muted">
            <DateFormatter date={invoice.dueDate!} />
          </small>
        </div>
      </div>
      <div className="col-2 text-right">
        <RoundButton
            asLink
            to={getInvoiceDetailRoute(
              invoice.invoiceType!,
              invoice.invoiceId!,
              invoice.proformaInvoiceId
            )}
          />
      </div>
    </div>
  );
};

export default InvoiceDashboardRow;
